import React from 'react';
import PageHeader from '../components/PageHeader';

const sections = [
  {
    icon: 'fa-user-tie',
    title: 'Acceptance of Terms',
    content: [
      'By accessing or using JobEntry, you agree to be bound by these Terms of Service.',
      'If you do not agree to these terms, please do not use our platform.',
      'We reserve the right to update these terms at any time with notice to users.',
      'Continued use of the platform after changes constitutes acceptance of the new terms.',
    ],
  },
  {
    icon: 'fa-id-card',
    title: 'Account Responsibilities',
    content: [
      'You must provide accurate and complete information when creating an account.',
      'You are responsible for maintaining the confidentiality of your login credentials.',
      'You must notify us immediately of any unauthorized use of your account.',
      'One person or entity may not maintain more than one free account.',
      'Accounts found to be fake or misleading will be permanently suspended.',
    ],
  },
  {
    icon: 'fa-briefcase',
    title: 'Employer Obligations',
    content: [
      'Job postings must be for genuine, legal employment opportunities.',
      'Employers must not post misleading, discriminatory, or fraudulent listings.',
      'Contact information in job postings must be accurate and reachable.',
      'Employers are responsible for all communications made through the platform.',
      'JobEntry reserves the right to remove any listing that violates these terms.',
    ],
  },
  {
    icon: 'fa-search',
    title: 'Job Seeker Obligations',
    content: [
      'Resume and profile information must be truthful and up to date.',
      'You must not apply to jobs with the intent to spam or mislead employers.',
      'Sharing or selling employer contact details obtained via the platform is prohibited.',
      'You agree not to use automated tools to scrape or bulk-apply to listings.',
    ],
  },
  {
    icon: 'fa-ban',
    title: 'Prohibited Activities',
    content: [
      'Posting or transmitting harmful, offensive, or illegal content',
      'Attempting to gain unauthorized access to other accounts or systems',
      'Using the platform to distribute spam, malware, or phishing content',
      'Reverse engineering, copying, or reselling any part of the platform',
      'Impersonating another person, company, or JobEntry staff',
    ],
  },
  {
    icon: 'fa-copyright',
    title: 'Intellectual Property',
    content: [
      'All platform content, design, and code is owned by Onexvora Business Solutions.',
      'You may not reproduce or distribute our content without written permission.',
      'User-submitted content (resumes, job posts) remains the property of the submitter.',
      'By submitting content, you grant JobEntry a license to display it on the platform.',
    ],
  },
  {
    icon: 'fa-exclamation-triangle',
    title: 'Limitation of Liability',
    content: [
      'JobEntry is a platform connecting employers and job seekers — we are not a recruiter.',
      'We do not guarantee employment outcomes or the accuracy of job listings.',
      'We are not liable for any direct or indirect damages arising from platform use.',
      'Our total liability shall not exceed the amount paid by you in the last 3 months.',
    ],
  },
  {
    icon: 'fa-gavel',
    title: 'Governing Law',
    content: [
      'These terms are governed by the laws of India.',
      'Any disputes shall be subject to the exclusive jurisdiction of courts in Noida, Uttar Pradesh.',
      'We encourage resolving disputes amicably before pursuing legal action.',
    ],
  },
];

export default function TermsOfService() {
  return (
    <>
      <PageHeader title="Terms of Service" breadcrumb="Terms of Service" />
      <section className="section-pad">
        <div className="container" style={{ maxWidth: 860 }}>

          <div className="policy-intro">
            <div className="policy-intro-icon" style={{ background: '#f3eeff', color: '#8b5cf6' }}><i className="fa fa-file-contract"></i></div>
            <div>
              <h4>Terms & Conditions</h4>
              <p>
                Please read these Terms of Service carefully before using <strong>JustHiring24</strong> (operated by Onexvora Business Solutions).
                These terms govern your access to and use of our platform, services, and content.
                Last updated: <strong>January 1, 2025</strong>.
              </p>
            </div>
          </div>

          {sections.map((s, i) => (
            <div className="policy-section" key={i}>
              <div className="policy-section-title">
                <div className="policy-section-icon"><i className={`fa ${s.icon}`}></i></div>
                <h5><span className="policy-section-num">{i + 1}.</span> {s.title}</h5>
              </div>
              <ul className="policy-list">
                {s.content.map((item, j) => (
                  <li key={j}><i className="fa fa-check-circle"></i><span>{item}</span></li>
                ))}
              </ul>
            </div>
          ))}

          <div className="policy-contact-box">
            <i className="fa fa-balance-scale"></i>
            <div>
              <h6>Legal Inquiries</h6>
              <p>For legal matters, contact us at <a href="mailto:onexverabusinesssolutions@gmail.com">onexverabusinesssolutions@gmail.com</a> or D-184, Sector-63, Noida, UP - 201301, India.</p>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
